import { submitInvoice } from './invoice-submission.js';

/**
 * Connects the mark-invoiced dialog to the API. Any page opens the dialog by dispatching
 * `billing-invoice-request` with `{item}`; a recorded invoice dispatches `billing-changed` on `document`.
 */
export class MarkInvoicedEventAdapter {
  #apiAdapter;
  #dialogComponent;
  #notificationComponent;
  #reloadPage;

  /**
   * @param {() => void} [reloadPage] reloads the app so index.js shows the login screen
   */
  constructor(apiAdapter, dialogComponent, notificationComponent, reloadPage = location.reload.bind(location)) {
    this.#apiAdapter = apiAdapter;
    this.#dialogComponent = dialogComponent;
    this.#notificationComponent = notificationComponent;
    this.#reloadPage = reloadPage;
  }

  connect() {
    document.addEventListener('billing-invoice-request', this.#onRequest);
    document.addEventListener('billing-invoice-submit', this.#onSubmit);
  }

  disconnect() {
    document.removeEventListener('billing-invoice-request', this.#onRequest);
    document.removeEventListener('billing-invoice-submit', this.#onSubmit);
  }

  #onRequest = (event) => {
    this.#dialogComponent.open(event.detail.item);
  };

  #onSubmit = (event) => {
    const { id, request } = event.detail;
    return submitInvoice(this.#dialogComponent, this.#notificationComponent, this.#reloadPage,
      () => this.#apiAdapter.markInvoiced(id, request));
  };
}
